module.exports = __webpack_public_path__ + "static/media/cor.c74c2636.jpeg";